import { fetchSettings, updateSettings } from 'api';
import { ISettings } from 'types';
import useAxios from 'hooks/useAxios';

const useFetchSettings = () => {
  const [request, { loading, error, data }] = useAxios<ISettings>();

  const handleFetchSettings = async () => {
    const settings = await request(fetchSettings());

    return settings;
  };

  return [handleFetchSettings, { loading, error: error?.data?.message, data }] as const;
};

const useUpdateSettings = () => {
  const [request, { loading, error, data }] = useAxios<ISettings>();

  const handleUpdateSettings = async (params: FormData) => {
    const updatedSettings = await request(updateSettings(params));

    return updatedSettings;
  };

  return [handleUpdateSettings, { loading, error: error?.data?.message, data }] as const;
};

export { useFetchSettings, useUpdateSettings };
